import { render, staticRenderFns } from "./my_disclosures_tab.vue?vue&type=template&id=0321d17a"
import script from "./my_disclosures_tab.vue?vue&type=script&lang=js"
export * from "./my_disclosures_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports